/* eslint-disable camelcase */
import moment from 'moment'

function buyButtonLogic () {
  if (window.theme.settings.template !== 'product.supadu') return
  const addToCart = document.querySelector('.add-to-cart')
  const item = window.theme.staticProductData
  if (!item) return
  const stock = window.theme.currentProductVariantStock
  const { sale_date } = item
  if (!sale_date || !sale_date.date) return
  const epochSaleDate = moment(sale_date.date).valueOf()
  const epochTomorrow = moment().add(1, 'days').valueOf()
  if (epochSaleDate >= epochTomorrow) {
    const productForm = document.querySelector('.js-product-single__form')
    productForm.innerHTML = `
      <button type="submit" name="add" class="btn btn--full add-to-cart btn--secondary" disabled="true">
        <span>Coming Soon</span>
      </button>
    `
    return
  }
  if (stock && stock <= 10) {
    addToCart.firstChild.nextSibling.innerHTML = 'Low Stock'
  }
}

function modifyCollectionFilterLabels () {
  if (window.theme.settings.template !== 'collection') return
  const filterGroups = document.querySelectorAll('.collection-sidebar__group')

  if (!filterGroups) return

  filterGroups.forEach(group => {
    const links = group.querySelectorAll('.tag a')
    links.forEach(link => {
      const words = link.innerText.split(' / ')
      if (words.length > 1) {
        const firstWord = `${words[0].charAt(0)}${words[0].slice(1).toLowerCase()}`
        words[0] = firstWord
        link.innerText = words.join(' > ')
      }
    })
  })
}

function customFunctions () {
  buyButtonLogic()
  modifyCollectionFilterLabels()

  // eslint-disable-next-line
  $(document).ajaxComplete(function(){
    modifyCollectionFilterLabels()
  })
}

module.exports = { customFunctions }
